
















import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
import { formatNumber, undoFormat } from '@/modules/shared/shared/domain/functions/format-number';

@Component({
    components: {
        VueTelInputVuetify,
    },
})
export default class PhoneField extends Vue {
    @PropSync('phoneData')
    public phone!: any;

    @Prop({ default: false })
    readonly?: boolean;

    @Prop({ default: false })
    disabled?: boolean;

    @Prop({ default: '' })
    label?: string;

    @Prop({ default: false })
    required?: boolean;

    mounted() {
        this.phone = formatNumber(this.phone);
    }

    phoneChanged(formattedNumber, { number, valid, country }) {
        this.phoneStatus.country = country && country.iso2;
        this.phoneStatus.valid = valid;
        this.phoneStatus.national = number.national;
        this.phoneStatus.international = number.international;
    }

    public phoneStatus = {
        country: 'VE',
        valid: true,
        national: '',
        international: '',
    };

    @Watch('phoneStatus.valid')
    onSecondPhoneValidChange(val: boolean) {
        if (!val) {
            const old = this.phone;
            this.phone = null;
            this.$nextTick(() => {
                this.phone = old;
            });
        } else {
            const old = this.phone;
            this.phone = this.phoneStatus.international;
            this.$nextTick(() => {
                this.phone = old;
            });
        }
    }

    public validate() {
        if (!this.phoneStatus.valid) {
            const old = this.phone;
            this.phone = null;
            this.$nextTick(() => {
                this.phone = old;
            });
        }
        return this.phoneStatus.valid;
    }

    public get correctFormatPhone(): string {
        return undoFormat(this.phoneStatus.national, this.phoneStatus.country);
    }
}
